<template>
  <li
    v-if="department"
    class="members__content department-list-item-menu"
    v-on="$listeners">
    <div
      class="d-flex align-items-center p-3">
      <p>
        <MaterialIcon
          class="members__icon mr-3"
          icon="people" />
      </p>
      <div class="members__content">
        <p class="members__name">
          {{ department.name }}
        </p>
      </div>
      <slot name="pin-icon" />
    </div>

    <transition name="list-menu">
      <div
        v-if="showMembers"
        @click.stop>
        <ul class="members__list list-unstyled">
          <slot />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  components: {
  },
  props: {
    department: {
      type: Object,
      default: null
    },
    showMembers: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/members.scss";

.list-menu-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-menu-leave-active {
  transition: all 0.1s;
}
.list-menu-enter, .list-menu-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}

.department-list-item-menu :hover{
  cursor: pointer;
}

.pin-icon-button {
  margin-left: auto;
}
</style>